export type WorkbenchMode = 'vertical-short' | 'film';
export type WorkbenchStepStatus = 'complete' | 'active' | 'locked';

export interface WorkbenchState {
  premiseReady: boolean;
  structureReady: boolean;
  scriptReady: boolean;
}

export interface WorkbenchStep {
  id: 'premise' | 'devices' | 'structure' | 'script' | 'review';
  label: string;
  description: string;
  status: WorkbenchStepStatus;
}

export function buildWorkbenchSteps(mode: WorkbenchMode, state: WorkbenchState): WorkbenchStep[] {
  const isFilm = mode === 'film';
  const completion = [
    state.premiseReady,
    state.premiseReady,
    state.structureReady,
    state.scriptReady,
    false,
  ];
  const firstIncomplete = completion.findIndex((complete) => !complete);
  const descriptions = isFilm
    ? [
        '明确长片命题、人物欲望与可持续冲突',
        '检索创作卡并规划装置的功能与兑现',
        '构建幕、序列与人物弧的因果结构',
        '按场景生成并持续校验伏笔与人物状态',
        '进入匿名盲审，记录证据而不消耗模型额度',
      ]
    : [
        '锁定受众、核心欲望与单集 1–3 分钟承诺',
        '检索创作卡，按功能候选装置而非套固定公式',
        '布局每集钩子、升级、爆点与跨集兑现',
        '生成可拍摄场景，并检查节奏、连续性与装置账本',
        '进入匿名盲审，少量验证且不消耗模型额度',
      ];
  const labels = ['创作设定', '戏剧装置', '结构蓝图', '成稿生成', '证据与盲审'];
  const ids: WorkbenchStep['id'][] = ['premise', 'devices', 'structure', 'script', 'review'];

  return ids.map((id, index) => ({
    id,
    label: labels[index],
    description: descriptions[index],
    status: completion[index] ? 'complete' : index === firstIncomplete ? 'active' : 'locked',
  }));
}
